import { render } from "./TheHeader.vue?vue&type=template&id=a891a06a&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=a891a06a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a891a06a"]])

export default __exports__